import { useState } from 'react';
import { ConfirmModal, enqueueSnackbar, GateDeleteModal } from '../../design-system';
import { GateInsPage, GateInsHeader, GateInsBody } from './GateInsComponents';
import { RoleGuard } from '../../routes';
import { ContainerGetOneQuery } from '../../types';
import { containersService } from '../../services';
import { i18n } from '../../i18n';
import { GateInReceiptPrint } from '../containers/GateInReceiptPrint';

export const GateIns = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);
  const [exportHandler, setExportHandler] = useState<(() => void) | null>(null);
  const [receiptContainer, setReceiptContainer] = useState<ContainerGetOneQuery | null>(null);

  const handlePrintReceipt = (id: string) => {
    containersService
      .get(id)
      .then((res) => setReceiptContainer(res.data.data))
      .catch(() => enqueueSnackbar(i18n.t('pages.gateInReceipt.loadError'), 'error'));
  };

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, i) => i);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <GateInsPage innerScroll>
        <GateInsHeader totalCount={totalCount} handleExportExcelClick={() => exportHandler?.()} />
        <GateInsBody
          setData={setData}
          setTotalCount={setTotalCount}
          checkIndexs={checkIndexs}
          setCheckIndexs={setCheckIndexs}
          handleCheckboxChange={handleCheckboxChange}
          setExportHandler={setExportHandler}
          onPrintReceipt={handlePrintReceipt}
        />
      </GateInsPage>
      <ConfirmModal />
      <GateDeleteModal />
      {receiptContainer && (
        <GateInReceiptPrint
          container={receiptContainer}
          onPrinted={() => setReceiptContainer(null)}
        />
      )}
    </RoleGuard>
  );
};
